var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "cloud_done"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_889_7460",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_889_7460)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cloud_done_2",
    d: "M8.62468 14.1666L13.333 9.45825L12.1247 8.24992L8.60384 11.7708L6.85384 10.0208L5.66634 11.2083L8.62468 14.1666ZM5.41634 16.6666C4.15245 16.6666 3.07259 16.2291 2.17676 15.3541C1.28092 14.4791 0.833008 13.4096 0.833008 12.1458C0.833008 11.0624 1.1594 10.0971 1.81217 9.24992C2.46495 8.4027 3.31912 7.86103 4.37467 7.62492C4.7219 6.34714 5.41634 5.31242 6.45801 4.52075C7.49967 3.72909 8.68023 3.33325 9.99967 3.33325C11.6247 3.33325 13.0031 3.89922 14.1351 5.03117C15.267 6.16311 15.833 7.54158 15.833 9.16658C16.7913 9.2777 17.5865 9.69089 18.2184 10.4062C18.8504 11.1214 19.1663 11.9583 19.1663 12.9166C19.1663 13.9583 18.8018 14.8437 18.0726 15.5728C17.3434 16.302 16.458 16.6666 15.4163 16.6666H5.41634ZM5.41634 14.9999H15.4163C15.9997 14.9999 16.4927 14.7985 16.8955 14.3958C17.2983 13.993 17.4997 13.4999 17.4997 12.9166C17.4997 12.3333 17.2983 11.8402 16.8955 11.4374C16.4927 11.0346 15.9997 10.8333 15.4163 10.8333H14.1663V9.16658C14.1663 8.01381 13.7601 7.03117 12.9476 6.21867C12.1351 5.40617 11.1525 4.99992 9.99967 4.99992C8.8469 4.99992 7.86426 5.40617 7.05176 6.21867C6.23926 7.03117 5.83301 8.01381 5.83301 9.16658H5.41634C4.61079 9.16658 3.92329 9.45131 3.35384 10.0208C2.7844 10.5902 2.49967 11.2777 2.49967 12.0833C2.49967 12.8888 2.7844 13.5763 3.35384 14.1458C3.92329 14.7152 4.61079 14.9999 5.41634 14.9999Z",
    fill: "#3BB77E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDone);
export default __webpack_public_path__ + "static/media/cloud_done.bd2afe2471f19bc35d84efc077d547fd.svg";
export { ForwardRef as ReactComponent };